module.exports = __webpack_public_path__ + "img/7_uk.4d8f6c59.svg";